import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { actualizarDatosParaMuiTable } from '../actions/TablaCamionesListosParaBrutoActions'
import TablaCamionesListosParaBrutoView from '../components/TablaCamionesListosParaBrutoView'

function TablaCamionesListosParaBruto (props) {
  const { actualizarDatosParaMuiTable, filtroInicial } = props

  useEffect(() => {
    actualizarDatosParaMuiTable(filtroInicial)
  }, [actualizarDatosParaMuiTable, filtroInicial])

  return <TablaCamionesListosParaBrutoView />
}

const mapActionsToProps = {
  actualizarDatosParaMuiTable
}
const withRedux = connect(null, mapActionsToProps)

export default withRedux(TablaCamionesListosParaBruto)
